import mixitup from 'mixitup';
import mixitupMultifilter from './mixitup-multifilter';

mixitup.use(mixitupMultifilter);

export default function insurance() {
	var target = document.querySelector('.insurance-mix');

	if (target) {
		var mixer = mixitup('.insurance-mix', {
			multifilter: {
				enable: true,
			},
			classNames: {
				block: '',
				delineatorElement: '_',
				delineatorModifier: '_',
			},
		});

		const allButton = document.getElementById('insurance-filter-all');

		allButton.addEventListener('click', function() {
			mixer.setFilterGroupSelectors('insurance', []);
			mixer.parseFilterGroups();
		});
	}
}

insurance();
